(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // Menü açma (tüm seviyeler için)
    document.addEventListener('click', function (e) {
      const button = e.target.closest('[data-sliderule-open]');
      if (button) {
        const targetId = button.getAttribute('data-sliderule-open');
        const wrapper = document.getElementById(targetId);
        const panel = wrapper?.querySelector('.sliderule__panel');

        if (panel) {
          panel.classList.add('is-visible');
        } else {
          console.warn('Alt panel bulunamadı:', targetId);
        }
      }
    });

    // Menü kapama (geri butonları)
    document.addEventListener('click', function (e) {
      const button = e.target.closest('[data-sliderule-close]');
      if (button) {
        const targetId = button.getAttribute('data-sliderule-close');
        const wrapper = document.getElementById(targetId);
        const panel = wrapper?.querySelector('.sliderule__panel');

        if (panel) {
          panel.classList.remove('is-visible');
        } else {
          console.warn('Geri panel bulunamadı:', targetId);
        }
      }
    });
  });
})();
